module.exports = __webpack_public_path__ + "static/img/store-value-code.e998329.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/store-value-code.png
// module id = JnHU
// module chunks = 1